module.exports = __webpack_public_path__ + "static/media/gpsp 25.634f2f40.png";